import { render, staticRenderFns } from "./PartCreate.vue?vue&type=template&id=f9b08222&"
import script from "./PartCreate.vue?vue&type=script&lang=ts&"
export * from "./PartCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports